import Link from "next/link";
import { ReactNode } from "react";
import styles from "./CheckList.module.css";
import { IconArrowUpRight } from "../ui-components/Icons/IconArrowUpRight";

export const TOTAL_STEPS = 4;

export interface CheckListItem {
  key: string;
  title: string;
  description?: ReactNode;
}

export interface CheckListItems {
  items: CheckListItem[];
}

export const checkListItems: CheckListItems = {
  items: [
    {
      key: "account",
      title: "Create an account",
    },
    {
      key: "query",
      title: "Create your first query",
      description: (
        <div>
          Try making a chart of the monthly gas spend for your wallet.
          <br />
          <Link
            href="https://dune.com/docs/learning/how-tos/create-your-first-query/"
            className={styles.link}
            target="_blank"
          >
            See guide <IconArrowUpRight />
          </Link>
        </div>
      ),
    },
    {
      key: "visualization",
      title: "Create your first visualization",
      description: (
        <div>
          Use your own query or fork someone else’s.
          <Link
            href="https://dune.com/docs/learning/how-tos/create-your-first-visualization/"
            className={styles.link}
            target="_blank"
          >
            See guide <IconArrowUpRight />
          </Link>
        </div>
      ),
    },
    {
      key: "share",
      title: "Share your query",
      description: (
        <div>
          Share your findings with teammates and social media.
          <Link
            href="https://dune.com/docs/learning/how-tos/share-your-query/"
            className={styles.link}
            target="_blank"
          >
            See guide <IconArrowUpRight />
          </Link>
        </div>
      ),
    },
  ],
};
